// src/components/SimpleYouTubePreview.js
import React from "react";
import { Box, IconButton, Typography } from "@mui/material";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";

/**
 * Hiç iframe kullanmayan, sadece tıklama ile doğrudan YouTube'a yönlendiren bileşen
 */
const SimpleYouTubePreview = ({ videoId, title }) => {
  // YouTube yüksek kalite thumbnail URL'si
  const thumbnailUrl = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;

  // Video URL'si
  const videoUrl = `https://www.youtube.com/watch?v=${videoId}`;

  // YouTube sayfasına yönlendirme
  const openYouTube = () => {
    window.open(videoUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <Box
      sx={{
        position: "relative",
        paddingTop: "56.25%", // 16:9 Aspect Ratio
        backgroundColor: "black",
        borderRadius: "8px",
        overflow: "hidden",
      }}
    >
      {/* Önizleme resmi */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundImage: `url(${thumbnailUrl})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.3)",
          },
          transition: "all 0.3s ease",
          "&:hover": {
            "&::before": {
              backgroundColor: "rgba(0, 0, 0, 0.5)",
            },
            "& .play-button": {
              transform: "scale(1.1)",
              backgroundColor: "rgba(255, 0, 0, 0.9)",
            },
          },
        }}
        onClick={openYouTube}
        aria-label={`Open video: ${title} on YouTube`}
      >
        <IconButton
          className="play-button"
          sx={{
            width: "70px",
            height: "70px",
            backgroundColor: "rgba(255, 0, 0, 0.7)",
            color: "white",
            zIndex: 2,
            transition: "all 0.3s ease",
            "&:hover": {
              backgroundColor: "rgba(255, 0, 0, 0.8)",
            },
          }}
          onClick={openYouTube}
        >
          <PlayArrowIcon sx={{ fontSize: "3rem" }} />
        </IconButton>

        {/* Video başlığı */}
        <Typography
          variant="subtitle1"
          sx={{
            color: "white",
            fontWeight: 600,
            position: "relative",
            zIndex: 2,
            mt: 2,
            textAlign: "center",
            px: 2,
            textShadow: "1px 1px 3px rgba(0,0,0,0.7)",
          }}
        >
          {title}
        </Typography>

        {/* YouTube yazısı */}
        <Box
          sx={{
            position: "absolute",
            bottom: 16,
            right: 16,
            padding: "4px 8px",
            backgroundColor: "rgba(255, 0, 0, 0.9)",
            borderRadius: "4px",
            zIndex: 2,
          }}
        >
          <Typography
            variant="caption"
            sx={{
              color: "white",
              fontWeight: 700,
              fontSize: "0.7rem",
            }}
          >
            YOUTUBE
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default SimpleYouTubePreview;
